import { render } from "./ActivityPopUpTables.vue?vue&type=template&id=71d694fd&scoped=true"
import script from "./ActivityPopUpTables.vue?vue&type=script&lang=js"
export * from "./ActivityPopUpTables.vue?vue&type=script&lang=js"

import "./ActivityPopUpTables.vue?vue&type=style&index=0&id=71d694fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d694fd"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QToggle,QTd,QTooltip,QSpinner,QTable});
